import { render, staticRenderFns } from "./foodSelect.vue?vue&type=template&id=67e15478&"
import script from "./foodSelect.vue?vue&type=script&lang=js&"
export * from "./foodSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports